import { useEffect, useState } from "react";
import axios from "axios";

const STORAGE_KEY = "anotador";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
const API = `${BACKEND_URL}/api/annotations`;

export function isAnotadorActivo() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function activarAnotador(activo = true) {
  try {
    if (activo) {
      window.localStorage.setItem(STORAGE_KEY, "true");
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
    window.dispatchEvent(new Event("anotador:cambio"));
  } catch {
    // ignore
  }
}

export function useAnotador() {
  const [activo, setActivo] = useState(() => isAnotadorActivo());
  useEffect(() => {
    const onChange = () => setActivo(isAnotadorActivo());
    window.addEventListener("storage", onChange);
    window.addEventListener("anotador:cambio", onChange);
    return () => {
      window.removeEventListener("storage", onChange);
      window.removeEventListener("anotador:cambio", onChange);
    };
  }, []);
  return activo;
}

export async function crearAnotacion(payload) {
  const { data } = await axios.post(API, payload);
  return data;
}

export async function listarAnotaciones({ veredicto, limit = 50 } = {}) {
  const params = {};
  if (veredicto) params.veredicto = veredicto;
  if (limit) params.limit = limit;
  const { data } = await axios.get(API, { params });
  return data;
}

export async function eliminarAnotacion(id) {
  const { data } = await axios.delete(`${API}/${encodeURIComponent(id)}`);
  return data;
}
